import {post, get, getFrom,post_query,post_blob } from "@/axios";


//库区列表 仓库状态中匹配库区名字
export const gridPage = function(params){
    return post('/wms/grid/gridPage',params)
}
//库区列表 仓库状态中匹配库区名字
export const RegionList = function(params){
    return get('/wms/region/RegionList',params)
}
//仓库列表
export const warehouseList = function(params){
    return get('/wms/warehouse/warehouseList',params)
}

//商品分页
export const stockPage = function (params) {
    return post('/wms/stock/stockPage', params)
}


//签收查询
export const signRecordPage = function (params) {
    return post('/wms/sign/signRecordPage', params)
}
//签收导出
export const signExport = function (params) {
    return post('/wms/sign/exportSignRecord', params)
}
//签收导出昨日
export const exportLastDay = function (params) {
    return post('/wms/sign/exportLastDay', params)
}
//签收导出上周
export const exportLastWeek = function (params) {
    return post('/wms/sign/exportLastWeek', params)
}
//移库台账 库区调拨单分页
export const transferPage = function (params) {
    return post('/wms/transfer/transferPage', params)
}



//操作记录
export const stockOperation = function (params) {
    return post('/wms/stock/stockOperation', params)
}



//仓库库存
export const pkgPage = function(params){
    return post('/wms/pkg/pkgPage',params)
}

//导出
export const exportPkgState = function(params){
    return post_blob('/wms/pkg/exportPkgState',params)
}



//移库台账导出
export const exportTransfer = function(params){
  return post('/wms/transfer/exportTransfer',params)
}

//移库台账导出_上周
export const exportTransferLastWeek = function(params){
  return post('/wms/transfer/exportLastWeek',params)
}

//移库台账导出_昨日
export const exportTransferLastDay = function(params){
  return post('/wms/transfer/exportLastDay',params)
}

//移库台账导出_昨日
export const stockHistory = function(params){
  return post('/wms/stock/history/page',params)
}


//批次包抵扣明细
export const pkgDeductionPage = function(params){
  return post('/wms/deduction/pkgDeductionPage',params)
}

//修改sku体积
export const batchUpdateVolume = function(params){
  return post('/wms/pkg/batchUpdateVolume',params)
}

//库存状态导出
export const exportQualityCheckDetails = function(params){
  return post('/wms/pkg/exportQualityCheckDetails',params)
}
// 查询尺码枚举
export const threeSideSumEnumsApi = function(params){
  return get('/overseas-wms/product/size/get/threeSideSumEnums',params)
}
// 查询尺码枚举
export const getByShopProductSkuApi = function(params){
  return get('/overseas-wms/product/size/getByShopProductSku',params)
}

//编辑尺寸
export const editShopProductSizeApi = function(params){
  return post('/overseas-wms/product/size/edit',params)
}

